import { isMealboxBasket, isMealboxBasketType } from "@chef/helpers";
import { useBillingQuery } from "@chef/state-management";
import { getAttribute } from "@chef/state-management/helpers";

export const useMySubscriptionMealbox = () => {
  const { data: billingQuery, isLoading } = useBillingQuery();

  const baskets = billingQuery?.billing.baskets;
  const preferences = billingQuery?.billing.preferences || [];
  const defaultBasket = baskets?.find(isMealboxBasketType);
  const basketProducts = defaultBasket?.basketProducts || [];
  const mealbox = basketProducts.find(isMealboxBasket);
  const variationObj = mealbox?.variation || { attributes: [], finalPrice: 0 };
  const portions = +(getAttribute("Portions", variationObj) || 0);
  const meals = +(getAttribute("Meals", variationObj) || 0);
  const mealboxPrice = variationObj.finalPrice;

  return {
    meals,
    portions,
    mealboxPrice,
    defaultBasket,
    mealbox,
    preferences,
    isLoading,
  };
};
